import { coreTimelineSynopsisGetAsyncSlice } from './get';

export const { requestGetCoreTimelineSynopsis, resetGetCoreTimelineSynopsis } =
	coreTimelineSynopsisGetAsyncSlice.asyncActionCreators;
